module.exports = __webpack_public_path__ + "static/media/toronto-mobile.add2de66.png";


//////////////////
// WEBPACK FOOTER
// ./src/semantic/dist/themes/fibrestream/assets/images/toronto-mobile.png
// module id = 979
// module chunks = 0